import {get, post, postJson} from './axios'

// 会员营销-会员分群
const RESOURCE_BASE_PATH = '/memberCrowd'

// 新增/编辑人群
export const addMemberCrowd = p => postJson(`${RESOURCE_BASE_PATH}/`, p);

// 人群交并差计算（用于精准营销中的计算人群）
export const packStatus = p => get(`${RESOURCE_BASE_PATH}/pack-status`, p);


